<google-map
	#deviceGoogleMap
	height="700px"
	width="100%"
	[zoom]="zoom"
	[center]="center"
	[options]="options"
	(idle)="boundsChanged($event)"
>
	<map-marker-clusterer
		#markerClusterer
		(clusterClick)="openClusterMarkerInfo($event)"
		data-automation-id="device-map-home-cluster"
	>
		@for (markerInfo of markersInfo; track markerInfo.deviceSn) {
			<map-marker
				#markerElem="mapMarker"
				[position]="markerInfo.marker.position!"
				[label]="markerInfo.marker.label!"
				[title]="markerInfo.marker.title!"
				[options]="{ icon: markerInfo.marker.icon }"
				(mapClick)="openInfo(markerElem)"
				data-automation-id="device-map-home-marker"
			>
			</map-marker>
		}

		@if (markersInfo.length.toString() >= mapVisibleDeviceCount || markersInfo.length === 0) {
			<div class="overlay">
				@if (markersInfo.length.toString() >= mapVisibleDeviceCount) {
					<span i18n="@@device-map-home-too-many-markers">
						<!-- an api end point (api/v1/dashboardSettings) will be created to pull the count from process.env.DASHBOARD_MAP_NUMBER_VISIBLE_DEVICES -->
						We only show {{ mapVisibleDeviceCount }} devices at a time. <br />Zoom in to narrow your search.
					</span>
				}
				@if (markersInfo.length === 0) {
					<span i18n="@@device-map-home-zero-markers">
						There are zero devices in this area. <br />
						Please zoom out to expand your search.
					</span>
				}
			</div>
		}
	</map-marker-clusterer>

	<map-info-window #mapInfoWindow>
		<div [innerHTML]="infoContent"></div>
	</map-info-window>
</google-map>
